
import { AiOutlineNumber } from 'react-icons/ai'

export const VidIcon = AiOutlineNumber

export const iotcnumberscheme = "TG-iotc-scheme"
export const imoscheme = "TG-imo-scheme"
export const tuvischeme = "TG-tuvi-scheme"
export const regnoscheme =  "TG-regno-scheme"
export const natnoscheme =  "TG-natno-scheme"
export const ircsscheme =  "TG-ircs-scheme"